// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// *************************************************************** roles assignment *****************************************************************
const UPDATE_BASIC_ROLE_USER_ASSIGNMENT_SUCCESS = 'UPDATE_BASIC_ROLE_USER_ASSIGNMENT_SUCCESS';
const UPDATE_BASIC_ROLE_POSITION_ASSIGNMENT_SUCCESS = 'UPDATE_BASIC_ROLE_POSITION_ASSIGNMENT_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// *************************************************************** roles assignment *****************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateUserSuccess(payload) {
  return {
    type: UPDATE_BASIC_ROLE_USER_ASSIGNMENT_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updatePositionSuccess(payload) {
  return {
    type: UPDATE_BASIC_ROLE_POSITION_ASSIGNMENT_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// *************************************************************** roles assignment *****************************************************************
/**
 *
 * @param {Number} role
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateUsers(role, data, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    if (app.can('RoleUsers@update')) {
      let loader = app.loading(app.translate('routes.home.basic.permission.Assigning Role Users'));

      api.put(`/role/${role}/users`, {data: {roleUsers: {users: data}}, params})
        .then((res) => {
          dispatch(_updateUserSuccess(res));
          loader.hide(() => app.message(app.translate('routes.home.basic.permission.Role Users Assigned Successfully')));
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() => app.error(
            err, 'routes.home.basic.role', 'عملیات بروزرسانی با شکست مواجه شد',
            app.translate('routes.home.basic.permission.Role User Assignment Failed'),
          ));
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          'routes.permission error',
          {
            permission: `${app.translate('routes.home.basic.permission.UserRoles', 'UserRoles')} - ${app.translate('routes.home.basic.permission.update', 'update')}`,
          },
          'permission error',
        ), 'error');
    }
  };
}

// /**
//  *
//  * @param {Number} role
//  * @param {Object} data
//  * @param {Object} [params={}]
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function updatePositions(role, data, params = {}, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     if (app.can('RolePositions@update')) {
//       let loader = app.loading(app.translate('routes.home.basic.permission.Assigning Role Positions'));
//
//       api.put(`/role/${role}/positions`, {data: {rolePositions: {positions: data}}, params})
//         .then((res) => {
//           dispatch(_updatePositionSuccess(res));
//           loader.hide(() => app.message(app.translate('routes.home.basic.permission.Role Positions Assigned Successfully')));
//           callback(undefined, res);
//         })
//         .catch((err) => {
//           loader.hide(() => app.error(
//             err, 'routes.home.basic.role', 'Role',
//             app.translate('routes.home.basic.permission.Role Position Assignment Failed'),
//           ));
//           callback(err);
//         });
//     } else {
//       callback(undefined);
//       app.message(
//         app.translate(
//           'routes.permission error',
//           {
//             permission: `${app.translate('routes.home.basic.permission.RolePositions', 'RolePositions')} - ${app.translate('routes.home.basic.permission.update', 'update')}`,
//           },
//           'permission error',
//         ), 'error');
//     }
//   };
// }

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
